import React from 'react';
import {
  centeredFull,
  defaultFont,
  themedText,
} from '../../../styles/SharedStyles';
import { useThemeContext } from '../../../context';
import './NoProjectFound.scss';

export interface NoProjectFoundProps {
  message: string;
}

export function NoProjectFound({ message }: NoProjectFoundProps): JSX.Element {
  const theme = useThemeContext();
  return (
    <p
      style={{
        ...defaultFont,
        ...centeredFull,
        ...themedText(theme),
      }}
      className='no-projects-p'
    >
      {message ? message : 'No projects found.'}
    </p>
  );
}
